import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

/**
 * Standalone loading screen overlay shown during the login → dashboard
 * transition while the admin profile is being fetched.
 *
 * Manages its own rotating subtitle messages internally.
 */
@Component({
  selector: 'app-loading-screen',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule],
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.css'
})
export class LoadingScreenComponent implements OnInit, OnDestroy {

  protected readonly loadingSubtitle = signal<string>('Cargando información de tu centro deportivo...');

  private readonly loadingMessages = [
    'Cargando información de tu centro deportivo...',
    'Verificando credenciales y permisos...',
    'Configurando tu panel personalizado...',
    'Conectando con la base de datos...',
    'Sincronizando canchas y reservas...',
    'Preparando interfaz de administración...',
    'Casi listo...'
  ];

  private messageInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.loadingSubtitle.set(this.loadingMessages[0]);
    let index = 1;
    this.messageInterval = setInterval(() => {
      if (index < this.loadingMessages.length) {
        this.loadingSubtitle.set(this.loadingMessages[index]);
        index++;
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
      this.messageInterval = null;
    }
  }
}
